import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './index.css';
import { App } from './App';

// Punto de entrada. El router va acá y no en `App.tsx` para que los tests puedan montar la app
// dentro de un `MemoryRouter` sin pelearse con un `BrowserRouter` ya montado.
const container = document.getElementById('root');
if (!container) throw new Error('No encontramos el nodo #root: index.html está mal armado');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
